import { CapabilityManager } from '@cinematic-engine/capabilities';
import { useEffect, useState } from 'react';
import { useStudio } from '../store/studio-store';

export function Diagnostics({ onClearSession }: { onClearSession?: () => void }) {
  const project = useStudio((s) => s.project);
  const currentFrame = useStudio((s) => s.currentFrame);
  const [fps, setFps] = useState(0);
  const [frameTime, setFrameTime] = useState(0);

  useEffect(() => {
    let raf = 0;
    let last = performance.now();
    let frames = 0;
    let acc = 0;

    function loop(now: number) {
      const dt = now - last;
      last = now;
      acc += dt;
      frames++;
      if (acc >= 500) {
        setFps((frames * 1000) / acc);
        setFrameTime(acc / frames);
        frames = 0;
        acc = 0;
      }
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  const caps = CapabilityManager.getInstance();

  return (
    <div className="diagnostics">
      <div className="diag-grid">
        <Diag label="FPS" value={fps.toFixed(1)} />
        <Diag label="Frame time" value={`${frameTime.toFixed(2)}ms`} />
        <Diag label="Frame" value={String(currentFrame)} />
        <Diag label="Frames total" value={String(project?.durationFrames ?? 0)} />
        <Diag label="Shot" value="—" />
        <Diag
          label="Backend"
          value={caps.supports('webgpu') ? 'WebGPU' : caps.supports('webgl2') ? 'WebGL2' : 'none'}
        />
        <Diag label="WebCodecs" value={caps.supports('webcodecs') ? 'yes' : 'no'} />
        <Diag label="Worker" value={caps.supports('workers') ? 'yes' : 'no'} />
        <Diag label="OffscreenCanvas" value={caps.supports('offscreenCanvas') ? 'yes' : 'no'} />
        <Diag label="Quality tier" value={caps.maxQualityTier} />
        <Diag
          label="Resolution"
          value={project ? `${project.format.width}×${project.format.height}` : '—'}
        />
        <Diag label="Codec" value="—" />
      </div>
      {onClearSession && (
        <div className="diag-footer">
          <button type="button" className="ghost-btn" onClick={onClearSession}>
            Clear saved session
          </button>
        </div>
      )}
    </div>
  );
}

function Diag({ label, value }: { label: string; value: string }) {
  return (
    <div className="diag-item">
      <div className="diag-label">{label}</div>
      <div className="diag-value">{value}</div>
    </div>
  );
}
